export const spinnerStatus = (state) => {

    return state.spinner;


}

